export default __webpack_public_path__ + "static/media/polgo-screenshot-04.c96c8577.png";